const constant = {
  REGION_VALUE_PARAMS: {
    placeholder: "Add Region",
    format: /^.{0,20}$/, // Use for validating new region length
  },
  DIVISION_VALUE_PARAMS: {
    placeholder: "Add Division",
    format: /^.{0,20}$/, // Use for validating new division length
  },
  VALID_OFFSET: [
    { label: "UTC -12:00", value: -12 },
    { label: "UTC -11:00", value: -11 },
    { label: "UTC -10:00", value: -10 },
    { label: "UTC -09:30", value: -9.3 },
    { label: "UTC -09:00", value: -9 },
    { label: "UTC -08:00", value: -8 },
    { label: "UTC -07:00", value: -7 },
    { label: "UTC -06:00", value: -6 },
    { label: "UTC -05:00", value: -5 },
    { label: "UTC -04:00", value: -4 },
    { label: "UTC -03:30", value: -3.3 },
    { label: "UTC -03:00", value: -3 },
    { label: "UTC -02:00", value: -2 },
    { label: "UTC -01:00", value: -1 },
    { label: "UTC +-00:00", value: 0 },
    { label: "UTC +01:00", value: 1 },
    { label: "UTC +02:00", value: 2 },
    { label: "UTC +03:00", value: 3 },
    { label: "UTC +03:30", value: +3.3 },
    { label: "UTC +04:00", value: 4 },
    { label: "UTC +04:30", value: +4.3 },
    { label: "UTC +05:00", value: 5 },
    { label: "UTC +05:30", value: +5.3 },
    { label: "UTC +05:45", value: +5.45 },
    { label: "UTC +06:00", value: 6 },
    { label: "UTC +06:30", value: +6.3 },
    { label: "UTC +07:00", value: 7 },
    { label: "UTC +08:00", value: 8 },
    { label: "UTC +08:45", value: +8.45 },
    { label: "UTC +09:00", value: 9 },
    { label: "UTC +09:30", value: +9.3 },
    { label: "UTC +10:00", value: 10 },
    { label: "UTC +10:30", value: +10.3 },
    { label: "UTC +11:00", value: 11 },
    { label: "UTC +12:00", value: 12 },
    { label: "UTC +12:45", value: +12.45 },
    { label: "UTC +13:00", value: 13 },
    { label: "UTC +14:00", value: 14 },
  ],
  MAX_LENGTH_50: 50,
  ACTIVE_ICON: "40",
  SMALL_ICON: "25",
  MAX_ZIP: 999999,
  MAX_ZIP_LENGTH: 6,
  TERMINAL_CODE_LENGTH: 3,
};

export default constant;
